/**
 * Powtoon OAuth helpers — orgDomain MUST come from the `?orgDomain=` query
 * param, then is persisted in sessionStorage. There is no default fallback;
 * callers must guard against a missing org domain.
 */

const ORG_DOMAIN_KEY = "powtoon_org_domain";

export function setOrgDomain(domain: string): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(ORG_DOMAIN_KEY, domain);
}

export function getOrgDomain(): string | null {
  if (typeof window === "undefined") return null;
  return window.sessionStorage.getItem(ORG_DOMAIN_KEY);
}

export function getRedirectUri(): string {
  const origin = window.location.origin.replace("://www.", "://");
  return `${origin}/process-authcode`;
}

const POWTOON_SCOPE_ENCODED = "read%20write%20live-avatars%3Aread%20live-avatars%3Awrite";

export function getAuthorizeUrl(clientId: string, state: string): string {
  const orgDomain = getOrgDomain();
  if (!orgDomain) {
    throw new Error("Missing orgDomain — open the app with ?orgDomain=<tenant>");
  }
  const redirectUri = encodeURIComponent(getRedirectUri());
  return `https://${orgDomain}.powtoon.com/oauth/authorize?response_type=code&scope=${POWTOON_SCOPE_ENCODED}&state=${state}&redirect_uri=${redirectUri}&client_id=${clientId}`;
}

export function generateNonce(): string {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return Array.from(array, (b) => b.toString(16).padStart(2, "0")).join("");
}
